import { api } from '../../services/fetch/api';

export interface Image {
    url: string;
    type: 'TEASER' | 'MAIL' | 'GALLERY' | string;
    order: number;
}
export interface Publication {
    id: string;
    campaignId: string;
    description?: string;
    status: 'ACTIVE' | 'INACTIVE';
    title: string;
    isCategory: boolean;
    teaserImage?: string;
}

export default class PublicationService {
    async loadPublications(page: number = 0, publicationCnt = 100, token: string): Promise<any> {
        const resp = await fetch(`${api.publication}?page=${page}&size=${publicationCnt}`, {
            method: 'GET',
            headers: {
                'Accept-Language': 'de-DE',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        if (resp.status === 200) {
            let rawPubs = await resp.json();
            return Promise.resolve(rawPubs._embedded.publicationList);
        }
        return Promise.reject('Unexpected error while loading publications');
    }

    async publication(publicationId: string | undefined, token: string): Promise<any> {
        if (!publicationId) {
            return Promise.reject('PublicationId is missing!');
        }
        const resp = await fetch(`${api.publication}/${publicationId}`, {
            method: 'GET',
            headers: {
                'Accept-Language': 'de-DE',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        if (resp.status === 200) {
            let publication = await resp.json();
            return Promise.resolve(publication);
        }
        return Promise.reject(
            `Unexpected error while loading publications: [Status code: ${resp.status} => ${
                resp.statusText
            } and body: ${await resp.text()} ]`
        );
    }

    async savePublication(publication: any, token: string): Promise<any> {
        const resp = await fetch(`${api.publication}`, {
            method: 'PUT',
            body: JSON.stringify(publication),
            headers: {
                'Accept-Language': 'de-DE',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        if (resp.status === 200) {
            return Promise.resolve(true);
        }
        return Promise.reject(
            `Error while patching publication: [Status code: ${resp.status} => ${
                resp.statusText
            } and body: ${await resp.text()} ]`
        );
    }

    mapToPublicationView(publications: any[]): Publication[] {
        return publications.map((p) => {
            return {
                id: p.id,
                title: p.title,
                campaignId: p.campaignId,
                description: p.description,
                isCategory: p.isCategory,
                status: p.status,
                teaserImage: p.flexVehicle?.images?.find((value: Image) => value.type === 'TEASER')?.url,
            };
        });
    }
}
